import { defineComponent, defineAsyncComponent } from 'vue';
import { BlockModule } from '../common'

new BlockModule({
    selector: '.block-downloads-shared-preview',
    vueComponent: defineComponent({
        name: 'block-downloads-shared-preview',
        components: {
            SocialShareDialog: defineAsyncComponent(
                () => import('@/components/website/social-share/SocialShareDialog.vue')
            ),
        },
    })
})
